module.exports = __webpack_public_path__ + "img/4.6061f681.png";